import { DataTable } from "@bleu.builders/ui";
import React from "react";
import { useParams } from "react-router-dom";

import { replaceParams } from "#/lib/pagesHelper";
import { useSWRDataTableWithRedirect } from "#/utils/useSWRDataTableWithRedirect";

import { ThesesTableBody } from "./ThesesTableBody";
import { ThesesTableToolbar } from "./ThesisTableToolbar";

export function ThesisTable({
  fetchPath,
  group = "tax",
  sort = "category",
  showGroupOptions = true,
  actions = null,
}) {
  const params = useParams();

  const { data, error, isLoading, tableState, setTableState } =
    useSWRDataTableWithRedirect(replaceParams(fetchPath, params), {
      grouping: [group],
      sorting: [{ id: sort, desc: false }],
      ...(params?.id
        ? {
            columnFilters: [{ id: "id", value: Number(params.id) }],
            expanded: true,
          }
        : {}),
    });

  const defaultOpen = params?.id ? true : false;

  return (
    <div className="my-10 space-y-4">
      <DataTable
        data={data}
        error={error}
        tableState={tableState}
        setTableState={setTableState}
        setSelectedData={null}
        setQueryToParams={true}
        isLoading={isLoading}
      >
        <div className="space-y-4">
          <ThesesTableToolbar
            showGroupOptions={showGroupOptions}
            actions={actions}
          />
          <ThesesTableBody defaultOpen={defaultOpen} />
        </div>
      </DataTable>
    </div>
  );
}
